import { render, staticRenderFns } from "./tool-bar-endpoint-select.vue?vue&type=template&id=80c0c02a&scoped=true&"
import script from "./tool-bar-endpoint-select.vue?vue&type=script&lang=ts&"
export * from "./tool-bar-endpoint-select.vue?vue&type=script&lang=ts&"
import style0 from "./tool-bar-endpoint-select.vue?vue&type=style&index=0&id=80c0c02a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "80c0c02a",
  null
  
)

export default component.exports